import config from '../../../../client/config'
import Axios, { AxiosResponse, AxiosError } from 'axios'
import humps from 'humps'
import { ApiStatus } from '../api_constant'
import { ApiError, ApiResponse } from './response'
import { SET_LOG } from '../../../../../lib/logger'

export const ApiTracking = {
  runningCount: 0,
  total: 0
}

export default class BaseApi {
  public basePath
  public version
  public path

  constructor() {
    this.basePath = config.apiPath
    this.version = config.apiVersion
    this.path = ''
  }

  get url() {
    return `${this.basePath}${this.version}${this.path}`
  }

  async runRequest(promiseRequest, trackingRunning = true) {
    // Traking API
    ApiTracking.total += 1
    if (trackingRunning) {
      ApiTracking.runningCount += 1
    }

    const response = await promiseRequest
      .then((response: AxiosResponse) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw new ApiError(ApiStatus.UNKNOW_ERROR, error.message ? [error.message] : [], error)
      })
      .finally(() => {
        if (trackingRunning) {
          ApiTracking.runningCount -= 1
        }
      })

    const apiStatus = getApiStatus(response)
    if (apiStatus === ApiStatus.SUCCESS) {
      const apiResponse = new ApiResponse(apiStatus, response.data.data, response.headers, response.data.meta)
      return apiResponse
    } else {
      const apiError = new ApiError(apiStatus, getMessages(response), response)
      throw apiError
    }
  }

  getRequest(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(
      Axios.get(this.url, {
        params: humps.decamelizeKeys(params),
        ...getHeader()
      }),
      trackingRunning
    )
  }

  putRequest(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(Axios.put(this.url, humps.decamelizeKeys(params), getHeader()), trackingRunning)
  }

  postRequest(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(Axios.post(this.url, humps.decamelizeKeys(params), getHeader()), trackingRunning)
  }

  patchRequest(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(Axios.patch(this.url, humps.decamelizeKeys(params), getHeader()), trackingRunning)
  }

  deleteRequest(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(
      Axios.delete(this.url, {
        params: humps.decamelizeKeys(params),
        ...getHeader()
      }),
      trackingRunning
    )
  }

  postFormData(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    return this.runRequest(
      Axios.post(this.url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }),
      trackingRunning
    )
  }

  putFormData(params = {}, trackingRunning = true) {
    params = this.handleParams(params)
    logRequestApi(this.url, params)
    return this.runRequest(
      Axios.put(this.url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }),
      trackingRunning
    )
  }

  private handleParams(params = {}){
    // Token setting
    if ((window as any).embedToken) {
      return {
        ...params,
        embedToken: (window as any).embedToken
      }
    }

    return params
  }
}

export const logRequestApi = (url: string, params: object) => {
  SET_LOG(`RequestUrl: ${url}`)
  SET_LOG(`Param: `)
  SET_LOG(params)
}

export const logResponseApi = (url: string, response: AxiosResponse) => {
  SET_LOG(`RequestUrl: ${url}`)
  SET_LOG(`response: `)
  SET_LOG(response)
}

export const getHeader = () => {
  return {}
}

export const getApiStatus = (response: AxiosResponse) => {
  if (response && response.data && response.data.status) {
    return response.data.status
  }
  return undefined
}

export const getMessages = (response: AxiosResponse) => {
  if (response && response.data && response.data.message) {
    return response.data.message
  }
  return []
}
